itsoftApp.createModule("fancybox", function () {
    var module = this;
    var queue = [];
    var libraryLoaded = false;
    var loadingStarted = false;

    var initQueue = function () {
        if (!libraryLoaded) {
            return false;
        }

        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module fancybox] initQueue function fired, queue.length: " + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };

    var loadAndInit = function () {
        var f = function () {
            libraryLoaded = true;
            initQueue();
        };

        // Случай, если библиотека вдруг уже загружена
        // (например, если она принудительна вставлена в html через <script>)
        itsoftApp.loadStyle("/assets/scripts/fancybox/fancybox.css");
        itsoftApp.loadScript("/assets/scripts/fancybox/fancybox.umd.js", function () {
            DEBUG && console.log("[module fancybox] library loaded, ready to init queue");
            f();
        });
    };

    var addEvent = function (func) {
        if (typeof func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraryLoaded) {

            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!loadingStarted) {
                loadingStarted = true;
                DEBUG && console.log("%c--[module fancybox] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }

            queue.push(func);
            DEBUG && console.log("[module fancybox] function added, count of functions to init now: " + queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };

    module.addEvent = addEvent;

    var setFancybox = function () {
        var createFancybox = function () {
            var initializedFancybox;
            var isInitialized = false;

            var initFancybox = function () {
                initializedFancybox = new Fancybox.bind('[data-fancybox]', {
                    mainClass: 'js-popup',
                    groupAttr: false,
                    Toolbar: false,
                    dragToClose: false,
                    autoFocus: false,
                  });

                if (initializedFancybox) {
                    isInitialized = true;
                }
            };

            initFancybox();
        };

        addEvent(createFancybox);
    };

    module.callback = setFancybox;
});